import { useEffect, useLayoutEffect, useSyncExternalStore } from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import type { Eu } from '../api';
import { Modal } from '../ui/Sobreposicoes';
import { MfaPainel } from '../../modules/sala360/MfaPainel';
import { definirEscopoMfa, lerPedidoMfa, limparPedidoMfa, observarMfa } from './ponte';

export function MfaSalaHost({ eu }: { eu: Eu }) {
  const pedido = useSyncExternalStore(observarMfa, lerPedidoMfa, () => null);
  const local = useLocation();
  const { t } = useTranslation('mfa');
  const qc = useQueryClient();
  const escopo = `${eu.usuario.id}/${eu.tenant_id}/${eu.workspace_id}`;
  useLayoutEffect(() => { definirEscopoMfa(escopo); return () => definirEscopoMfa(''); }, [escopo]);
  useEffect(() => { if (!local.pathname.startsWith('/sala360')) limparPedidoMfa(); }, [local.pathname]);
  async function continuar() {
    // Leituras são consultadas novamente; escritas negadas nunca são repetidas automaticamente.
    limparPedidoMfa();
    await qc.invalidateQueries({ predicate: (q) => q.queryKey[0] === 'sala360' || q.queryKey[0] === 'eu' });
  }
  const aberto = !!pedido && local.pathname.startsWith('/sala360');
  return <Modal aberto={aberto} aoFechar={limparPedidoMfa} titulo={t(pedido?.acao === 'inscrever' ? 'conviteTitulo' : 'verificarTitulo')} largura="max-w-md">
    {aberto && pedido && <MfaPainel key={`${escopo}/${pedido.acao}`} acao={pedido.acao} aoContinuar={() => void continuar()} aoInscrever={limparPedidoMfa} />}
  </Modal>;
}
